import { render, staticRenderFns } from "./dongjie.vue?vue&type=template&id=3f432486"
import script from "./dongjie.vue?vue&type=script&lang=js"
export * from "./dongjie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports